import './Users.sass';

import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import UserProfile from '../../../commonComponents/UserProfile/UserProfile';
import UsersListStateful from '../../../commonComponents/UsersList/UsersListStateful';
import * as api from '../../../utilities/ServiceManager';
import Activity from './Activity/Activity';
import NewStudent from './NewStudent';
import Statistics from './Statistics/Statistics';

const DEFAULT_USER_FILTERS = {
  search: '',
  email: '',
  name: '',
  lastName: '',
  filterBySubscription: '',
  filterByRate: '',
  sortBy: 'lastName',
};

class Users extends React.Component {
  static propTypes = {
    users: PropTypes.array,
    pagination: PropTypes.object.isRequired,
    getUsersFunction: PropTypes.func.isRequired,
  };

  state = {
    users: [],
    newStudent: false,
    filters: DEFAULT_USER_FILTERS,
    reloadCycle: false,
    page: 0,
  };

  componentWillUnmount() {
    this.props.cleanUsers();
  }

  componentWillMount() {
    // Don't load new users if they have been loaded already
    if (
      this.props.users.length === 0 ||
      !this.hasActiveFilters(this.state.filters)
    ) {
      this.getUsers();
    }
  }

  componentWillReceiveProps({ users = [], selectedUser }) {
    const updateState = { loading: false };
    if (this.props.selectedUser?.id && !this.state.fetchedUser) {
      this.props.loadSelectedUser(this.props.selectedUser.id);
      this.setState({ fetchedUser: true });
    }

    if (users.length && !this.props.selectedUser.id) {
      const profile = users.find(
        (user) => user.id === this.props.selectedUser.id,
      );
      this.props.setSelectedUser(profile || users[0]);
    }
    const queryCycles = `rank=${selectedUser.rank}&dutyState=${selectedUser.dutyState}&userId=${selectedUser.id}`;
    if (selectedUser?.id && selectedUser.id !== this.props.selectedUser.id) {
      this.props.loadUserSubscription(selectedUser);
      this.getUserCycles(queryCycles);
      this.props.getUserNote(selectedUser.id);
      this.props.getCouponUserAction(selectedUser.id);
      this.props.getCancellationReason(selectedUser.id);
      this.props.getCancellationNoteAction(selectedUser.id);
      this.props.loadApplicableCoupons(selectedUser.id);
      this.props.getUserVerification(selectedUser.id);
      this.props.getUserEducationalInstitutionData(selectedUser.id);
      this.props.getBetaUser(selectedUser.id);
      this.props.getDoubleSubStatus(selectedUser.id);
    }
    if (this.state.reloadCycle) {
      this.getUserCycles(queryCycles);
      this.setState({ reloadCycle: false });
    }
    this.setState(updateState);
  }

  getUserStatus = async (info) => {
    const queryStatus = `id=${info.userId}&isStudent=${info.isStudent}`;
    try {
      await api.getUserStatus(queryStatus).then((data) => {
        if (data.data != null) {
          const time = new Date();
          const activity = data.data.path;
          const when = data.data.time;
          const diff = time - when;
          const isNowActive = diff < 120000;
          const mobile = data.data.isMobile;
          this.setState({
            path: activity,
            isNowActive,
            mobile,
          });
        } else {
          this.setState({ isNowActive: false });
        }
      });
    } catch (error) {}
  };

  getUserCycles = async (queryCycles) => {
    try {
      await api.findCyclesByUser(queryCycles).then((data) => {
        this.setState({ cyclesList: data.data });
      });
    } catch (err) {}
  };

  updateCycle = () => {
    this.setState({ reloadCycle: true });
  };

  loadCycles = (query) => {
    if (query.indexOf('undefined') === -1) {
      this.getUserCycles(query);
    }
  };

  normalizeFilters = (filtersOrSearch, filterBySubscription, filterByRate) => {
    if (filtersOrSearch && typeof filtersOrSearch === 'object') {
      return {
        ...DEFAULT_USER_FILTERS,
        ...filtersOrSearch,
      };
    }

    return {
      ...this.state.filters,
      search: filtersOrSearch || '',
      filterBySubscription:
        filterBySubscription === undefined
          ? this.state.filters.filterBySubscription
          : filterBySubscription,
      filterByRate:
        filterByRate === undefined
          ? this.state.filters.filterByRate
          : filterByRate,
    };
  };

  hasActiveFilters = (filters) =>
    filters.search ||
    filters.email ||
    filters.name ||
    filters.lastName ||
    filters.filterBySubscription ||
    filters.filterByRate ||
    filters.sortBy !== DEFAULT_USER_FILTERS.sortBy;

  getUsers = (filters = this.state.filters, page = 0) => {
    const normalizedFilters = this.normalizeFilters(filters);
    this.setState({ loading: true });
    this.props.getUsersFunction(normalizedFilters, page);
  };

  setSearch = (filtersOrSearch, filterBySubscription, filterByRate) => {
    const filters = this.normalizeFilters(
      filtersOrSearch,
      filterBySubscription,
      filterByRate,
    );
    this.props.cleanUsers();
    this.setState({
      loading: true,
      filters,
      page: 0,
    });
    this.debounce(() => this.getUsers(filters, 0), 500);
  };

  debounce = (func, wait = 500, immediate = false, ...theArgs) => {
    const context = this;
    const args = theArgs;
    const later = () => {
      this.timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !this.timeout;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };

  getUserStatistics = (user, page = 1) => {
    this.props.loadUserStatistics(user, page);
  };

  toggleNew = () => {
    this.props.setIsNewStudent(!this.props.isNewStudent);
  };

  changePage = (page) => {
    this.setState({ page });
    this.debounce(() => this.getUsers(this.state.filters, page), 500, true);
  };

  render() {
    return (
      <div className="usersSectionContainer">
        <Row className="containerRow">
          <Col
            xs={3}
            md={3}
            lg={3}
            style={{
              paddingRight: '0px',
              paddingLeft: '0px',
              maxWidth: '480px',
              minWidth: '320px',
            }}
            className="usersListSector"
          >
            <div className="usersListContainer">
              <UsersListStateful
                ref={(ref) => (this.usersListStateful = ref)}
                filters={this.state.filters}
                search={this.state.filters.search}
                filterBySubscription={this.state.filters.filterBySubscription}
                filterByRate={this.state.filters.filterByRate}
                rates={this.props.rates}
                loading={this.state.loading}
                users={this.props.users}
                profile={this.props.selectedUser}
                getUsers={this.getUsers}
                pagination={this.props.pagination}
                page={this.state.page}
                changePage={this.changePage}
                toggleNew={this.toggleNew}
                newStudent={this.props.isNewStudent}
                setSelectedUser={this.props.setSelectedUser}
                loadUserStatistics={this.getUserStatistics}
                permissions={this.props.permissions}
                setSearch={this.setSearch}
              />
            </div>
          </Col>
          <Col
            xs={this.props.isNewStudent ? 6 : 3}
            md={this.props.isNewStudent ? 6 : 3}
            style={{
              paddingRight: '0px',
              paddingLeft: '0px',
              maxWidth: '480px',
              minWidth: '320px',
              padding: '15px',
            }}
          >
            <div className="userProfileContainer">
              {this.props.isNewStudent ? (
                <NewStudent
                  ref={(ref) => (this.newStudent = ref)}
                  toggleNew={this.toggleNew}
                  rates={this.props.rates}
                  loadRates={this.props.loadRates}
                  handleSubmit={this.props.handleSubmit}
                  createStudent={this.props.createStudent}
                  loading={this.props.loading}
                  plans={this.props.plans}
                  loadPlans={this.props.loadPlans}
                  creationResponse={this.props.creationResponse}
                  resetForm={this.props.resetForm}
                  message={this.props.message}
                  setMessage={this.props.setMessage}
                  getUsers={this.getUsers}
                  loadUserStatistics={this.props.loadUserStatistics}
                  setSelectedUser={this.props.setSelectedUser}
                  onSetSearch={this.setSearch}
                  setNewStudentError={this.props.setNewStudentError}
                  newStudentError={this.props.newStudentError}
                />
              ) : (
                <UserProfile
                  onShowNotification={this.props.onShowNotification}
                  profile={this.props.selectedUser}
                  onDelete={this.props.deleteUser}
                  onResetUserQuestions={this.props.onResetUserQuestions}
                  onResetPassword={this.props.resetPassword}
                  onToggleActive={this.props.toggleActive}
                  onUnlockUser={this.props.unlockUser}
                  updateUser={this.props.updateUser}
                  rates={this.props.rates}
                  loadRates={this.props.loadRates}
                  permissions={this.props.permissions}
                  loginAs={this.props.loginAs}
                  userSubscription={this.props.userSubscription}
                  updateUserSubscription={this.props.updateUserSubscription}
                  forcePasswordUpdate={() =>
                    this.props.forcePasswordUpdate(this.props.selectedUser)
                  }
                  cycles={this.state.cyclesList}
                  updateCycle={this.updateCycle}
                  loadCycles={this.loadCycles}
                  restartPracticeExam={this.props.restartPracticeExam}
                  restartPracticeExamWaiting={
                    this.props.restartPracticeExamWaiting
                  }
                  setRestartPracticeExamSuccess={
                    this.props.setRestartPracticeExamSuccess
                  }
                  restartPracticeExamSuccess={
                    this.props.restartPracticeExamSuccess
                  }
                  applicableCoupons={this.props.applicableCoupons}
                  userVerification={this.props.userVerification}
                  getUserVerification={this.props.getUserVerification}
                  setUserVerification={this.props.setUserVerification}
                  couponUser={this.props.couponUser}
                  blockUser={this.props.blockUser}
                  userAdmin={this.props.user}
                  showChangeExamTypeModal={this.props.showChangeExamTypeModal}
                  setShowChangeExamTypeModal={
                    this.props.setShowChangeExamTypeModal
                  }
                  countByDate={
                    this.props.statistics.data ? this.props.statistics.data : []
                  }
                  getUserSubscriptionUser={this.props.getUserSubscriptionUser}
                  userSubscriptionHistory={this.props.userSubscriptionHistory}
                  loadingSubscriptionHistory={
                    this.props.loadingSubscriptionHistory
                  }
                  doubleSubStatus={this.props.doubleSubStatus}
                  loadingDoubleSubInfo={this.props.loadingDoubleSubInfo}
                />
              )}
            </div>
          </Col>
          {!this.props.isNewStudent && (
            <Col
              xs={3}
              md={3}
              lg={3}
              style={{
                paddingRight: '0px',
                paddingLeft: '0px',
                maxWidth: '480px',
                minWidth: '320px',
                padding: '15px',
              }}
            >
              <Statistics
                user={this.props.selectedUser}
                statistics={this.props.statistics}
                isNowActive={this.state.isNowActive}
                mobile={this.state.mobile}
                path={this.state.path}
                noteDoNotContact={this.props.noteDoNotContact}
                setDoNotContact={this.props.setDoNotContact}
                getUserNote={this.props.getUserNote}
                setIntercomCancellation={this.props.setIntercomCancellation}
                getCancellationReason={this.props.getCancellationReason}
                reasonCancellation={this.props.reasonCancellation}
                upadteCancellationReason={this.props.upadteCancellationReason}
                intercomCancellationReason={
                  this.props.intercomCancellationReason
                }
                updateEducationalInstitutionData={
                  this.props.updateEducationalInstitutionData
                }
                getUserEducationalInstitutionData={
                  this.props.getUserEducationalInstitutionData
                }
                educationalInstitutionData={
                  this.props.educationalInstitutionData
                }
                setUserSubmissionBlockStatus={
                  this.props.setUserSubmissionBlockStatus
                }
                isLoadingBlockStatus={this.props.isLoadingBlockStatus}
                setUserFavoriteBlockStatus={
                  this.props.setUserFavoriteBlockStatus
                }
                isLoadingFavoriteBlockStatus={
                  this.props.isLoadingFavoriteBlockStatus
                }
                setUserReferralBlockStatus={
                  this.props.setUserReferralBlockStatus
                }
                isLoadingReferralBlockStatus={
                  this.props.isLoadingReferralBlockStatus
                }
                setCheckBetaUser={this.props.setCheckBetaUser}
                isBetaUser={this.props.isBetaUser}
                permissions={this.props.permissions}
              />
            </Col>
          )}
          {!this.props.isNewStudent && (
            <Col
              xs={3}
              md={3}
              lg={3}
              style={{
                paddingRight: '0px',
                paddingLeft: '0px',
                maxWidth: '480px',
                minWidth: '320px',
                padding: '15px 30px 15px 15px',
              }}
            >
              <Activity
                user={this.props.selectedUser}
                countByDate={
                  this.props.statistics.data ? this.props.statistics.data : []
                }
                loading={this.props.loadingInfo}
                pagination={this.props.activityPagination}
                loadUserStatistics={this.props.loadUserStatistics}
                filtered={
                  this.props.statistics.filterUsed
                    ? this.props.statistics.filterUsed
                    : 'All Activity'
                }
              />

              {this.props.listNewCycles &&
              this.props.listNewCycles.length > 0 ? (
                <div>
                  <ProfileSheet
                    user={this.props.selectedUser}
                    listNewCycles={
                      this.props.listNewCycles &&
                      Object.keys(this.props.listNewCycles).length !== 0
                        ? this.props.listNewCycles
                        : []
                    }
                    setDisableCyleAction={this.props.setDisableCyleAction}
                    getCylesInformation={this.props.getCylesInformation}
                    disableCycle={this.props.disableCycle}
                  />
                </div>
              ) : (
                <div className="notCycles">
                  <span>Profile sheet information not available</span>
                </div>
              )}
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export default Users;
